import React from 'react';
import {usePaymentContext} from '../../contexts/PaymentContext';
import {usePaymentCreditCardContext} from '../../contexts/PaymentCreditCardContex';
import InputInvoice from '../InputInvoice';

const FieldInvoiceCreditCard = () => {
  const {loadInvoiceOptions, onInvoiceChanged, updateForm} = usePaymentCreditCardContext();
  const {invoiceOrder} = usePaymentContext();

  return (
    <InputInvoice
      loadInvoiceOptions={loadInvoiceOptions}
      onInvoiceChanged={onInvoiceChanged}
      updateForm={updateForm}
      invoiceOrder={invoiceOrder}
    />
  );
};

export default FieldInvoiceCreditCard;
